
// @ts-ignore: Deno resolution for client side modules
import * as BABYLON from "babylonjs";

// @ts-ignore: Deno resolution
import { AttackPlayer } from "../../shared/types.ts";
// @ts-ignore: Deno resolution
import { Character } from "./characters/Character.ts";
// @ts-ignore: Deno resolution
import { LocalCharacter } from "./characters/LocalCharacter.ts";

export enum AnimationState {
  IDLE = "IDLE",
  RUN = "RUN",
  RUN_BACKWARD = "RUN_BACKWARD",
  RUN_LEFT = "RUN_LEFT",
  RUN_RIGHT = "RUN_RIGHT",
  WALK = "WALK",
  CROUCH_IDLE = "CROUCH_IDLE",
  CROUCH_WALK = "CROUCH_WALK",
  CROUCH_WALK_BACKWARD = "CROUCH_WALK_BACKWARD",
  CROUCH_WALK_LEFT = "CROUCH_WALK_LEFT",
  CROUCH_WALK_RIGHT = "CROUCH_WALK_RIGHT",
  JUMP_START = "JUMP_START",
  JUMP_AIR = "JUMP_AIR",
  JUMP_LAND = "JUMP_LAND",
  SHOOT = "SHOOT",
  RELOAD = "RELOAD",
  DEATH = "DEATH",
}

export interface PlayerAnims {
  [key: string]: BABYLON.AnimationGroup | undefined;
}

export interface PlayerState extends AttackPlayer {
  root?: BABYLON.TransformNode;
  mesh?: BABYLON.AbstractMesh;
  character?: Character;
  
  flashlight?: BABYLON.SpotLight;
  flashlightSpill?: BABYLON.PointLight;
  flashlightMesh?: BABYLON.AbstractMesh;
  flMount?: BABYLON.TransformNode;
  weaponMesh?: BABYLON.AbstractMesh;
  weaponContainers?: {
    rightHand: BABYLON.TransformNode | null;
    leftHand: BABYLON.TransformNode | null;
  };

  // Animation System
  animationState?: AnimationState;
  animationController?: any; // Avoiding circular dependency for now, will cast
  anims?: PlayerAnims;

  // Interpolation
  targetX?: number;
  targetY?: number;
  targetZ?: number;
  targetRot?: number;
  targetPitch?: number;
  
  // Loading state
  isPendingMeshCreation?: boolean;
}

export interface GameState {
  scene: BABYLON.Scene | null;
  engine: BABYLON.Engine | null;
  camera: BABYLON.FreeCamera | null;
  localPlayer: BABYLON.Mesh | null; // Legacy mesh connection
  localCharacter: LocalCharacter | null; // New system
  socket: WebSocket | null;
  players: Record<string, PlayerState>;
  myId: string | null;
  canvas: HTMLCanvasElement | null;
  flashlight: BABYLON.SpotLight | null;
  proximityLight: BABYLON.PointLight | null;
  isLoading: boolean;
  hasMoved: boolean;
  soldierModel: BABYLON.Mesh | null;
  soldierAnims: {
    idle?: BABYLON.AnimationGroup;
    run?: BABYLON.AnimationGroup;
  };
  soldierContainer: BABYLON.AssetContainer | null;
  soldierModelUrl: string | null;  // For direct import approach
  soldierTextureUrl: string | null;
  weaponTextureUrl: string | null;
  uniformTextures: Record<string, BABYLON.Texture>;
  militiaContainer: BABYLON.AssetContainer | null;
  militiaModelUrl: string | null;
  militiaTextures: Record<string, BABYLON.Texture>;
  knifeContainer: BABYLON.AssetContainer | null;
  
  // Model specific metadata (cache)
  soldierParts?: any;
  militiaParts?: any;
}

export const state: GameState = {
  scene: null,
  engine: null,
  camera: null,
  localPlayer: null,
  localCharacter: null,
  socket: null,
  players: {},
  myId: null,
  canvas: null,
  flashlight: null,
  proximityLight: null,
  isLoading: false,
  hasMoved: false,
  soldierModel: null,
  soldierAnims: {},
  soldierContainer: null,
  soldierModelUrl: null,
  soldierTextureUrl: null,
  weaponTextureUrl: null,
  uniformTextures: {},
  militiaContainer: null,
  militiaModelUrl: null,
  militiaTextures: {},
  knifeContainer: null,
};
